export const refsM = {
  form: document.querySelector('.search-cocktails'),
  gellery: document.querySelector('.gellery'),
  notify: document.querySelector('.deleted-notify'),
  pagination: document.querySelector('.pagination-list-favorite'),
  erroreImg: document.querySelector('.alex-error-img-container '),
  titleFav: document.querySelector('.title-fav'),
};
